export default {
  title: 'Projects',
  titleButton: 'New project',
  titleButtonShort: 'New',
  cards: {
    actions: {
      edit: 'Edit project name',
      share: 'Share',
      delete: 'Delete project'
    },
    footer: {
      assetsCount: '{count} assets'
    }
  },
  emptyState: {
    noProjectsCreated: "You haven't created any projects yet",
    button: 'Create your first project',
    noProjectsBeenShared: 'No projects have been shared with you yet.'
  },
  createDialog: {
    ariaLabel: 'Create project form dialog',
    title: 'Create new project',
    createButton: 'Create project',
    fields: {
      title: 'Project name',
      titlePlaceholder: 'Type the project name'
    },
    success: 'Project created successfully'
  },
  filters: {
    total: `{itemCount} {itemCount, plural,
      one {project}
      other {projects}
    }`
  },
  editDialog: {
    ariaLabel: 'Edit project form dialog',
    title: 'Edit project name',
    saveButton: 'Save changes',
    fields: {
      title: 'Project name',
      titlePlaceholder: 'Type the project name'
    },
    success: 'Name changed successfully'
  },
  deleteDialog: {
    ariaLabel: 'Delete project form dialog',
    title: 'Delete project',
    description: 'Are you sure you want to delete {name}?',
    warning: 'This action cannot be undone.',
    info: "Assets inside this project won't be deleted.",
    deleteButton: 'Yes, delete',
    success: 'Project deleted successfully'
  }
}
